import { BillableServiceUIModel } from "@/Administration/Models/UI/BillableService/BillableServiceUIModel";
import { AdministrationStore } from "@/Administration/Stores/AdministrationStore";
import { BillableServiceItem } from "@/Common/Models/BillableServiceItem";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";

class AdministrationBillableServiceResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);
        this.RegisterOperation(ServerOperations.Server.Myle_Admin_GetAllBillableService, this.refreshBillableServices);
        this.RegisterOperation(ServerOperations.Server.Myle_Admin_UpsertBillableService, this.upsertBillableService);
    }

    private refreshBillableServices(response: ServerEvent, store: AdministrationStore): void {
        let services: BillableServiceItem[] = response.Data["BillableServices"];
        let servicesUIModel: BillableServiceUIModel[];

        if (services) {
            servicesUIModel = services.map(x => BillableServiceUIModel.fromCompositeObject(x));
            if (servicesUIModel) {
                store.billableServiceTabModel = store.billableServiceTabModel.set("FilteredBillableServices", servicesUIModel.toImmutable());

                store.billableServiceTabModel = store.billableServiceTabModel.set("TotalQueryPages", response.Data.TotalQueryPages);
                store.billableServiceTabModel = store.billableServiceTabModel.set("TotalQueryRows", response.Data.TotalQueryRows);
                store.billableServiceTabModel = store.billableServiceTabModel.set("CurrentPage", response.Data.CurrentPage);
            }
        }
    }

    private upsertBillableService(response: ServerEvent, store: AdministrationStore): void {
        let isSuccess: boolean = response.Data["IsSuccess"];

        if (isSuccess) {
            store.billableServiceAction.LoadFilteredBillableService(store.billableServiceTabModel);

            let isOpen = store.billableServiceTabModel.get("DisplayEditBillableServiceComponent");
            store.billableServiceTabModel = store.billableServiceTabModel.set("DisplayEditBillableServiceComponent", !isOpen);
        }

        if (response.hasErrors())
            sessionStore.showPopup(response.Errors);
    }
}

export { AdministrationBillableServiceResponseHandler };
